import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';

export const styledBackstagePage = (
  theme: Theme,
): BackstageOverrides['BackstagePage'] => ({
  root: {
    background: `linear-gradient(180deg, ${alpha(
      theme.palette.primary.light,
      theme.palette.mode === 'dark' ? 0.08 : 0.28,
    )} 0%, ${theme.palette.background.default} 220px)`,
    backgroundColor: theme.palette.background.default,
    minWidth: 0,
    overflowX: 'hidden',
  },
});
